import { render, staticRenderFns } from "./EffectChainEditor.vue?vue&type=template&id=3bd86de0&scoped=true&"
import script from "./EffectChainEditor.vue?vue&type=script&lang=js&"
export * from "./EffectChainEditor.vue?vue&type=script&lang=js&"
import style0 from "./EffectChainEditor.vue?vue&type=style&index=0&id=3bd86de0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd86de0",
  null
  
)

export default component.exports